'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconForFormat = getIconForFormat;
exports.getDigitalFormatTypeString = getDigitalFormatTypeString;
exports.getDefaultImage = getDefaultImage;
var iconMap = {
  AB: 'icon icon-headphones',
  ACCESSIBLE_FORMATS: 'icon icon-font',
  AUDIOBOOKS_SPOKEN_WORD: 'icon icon-headphones',
  BK: 'icon icon-book-open',
  BLURAY: 'icon icon-cd',
  BOARD_BK: 'icon icon-book-open',
  BOOK_CD: 'icon icon-headphones',
  BOOK_PCD: 'icon icon-book-open',
  BOOKS: 'icon icon-book-open',
  CDROM: 'icon icon-cd',
  CS: 'icon icon-headphones',
  DVD: 'icon icon-cd',
  EBOOK: 'icon icon-tablet',
  DEVICE: 'icon icon-tablet',
  FILM: 'icon icon-videocam',
  GAMES_INTERACTIVE_MEDIA: 'icon icon-gamepad',
  GRAPHIC_NOVEL: 'icon icon-book-open',
  JOURNALS_MAGAZINES: 'icon icon-newspaper',
  LPRINT: 'icon icon-font',
  MN: 'icon icon-music',
  MOVIES_TV_VIDEO: 'icon icon-videocam',
  MP3_CD: 'icon icon-headphones',
  MUSIC_CD: 'icon icon-music',
  MUSIC_CS: 'icon icon-music',
  MUSIC_MP3_CD: 'icon icon-music',
  MUSIC_SOUND: 'icon icon-music',
  MUSIC_DOWNLOAD: 'icon icon-music',
  MUSIC_ONLINE: 'icon icon-music',
  LP: 'icon icon-music',
  NEWSPAPER: 'icon icon-newspaper',
  MAG: 'icon icon-newspaper',
  EJ: 'icon icon-newspaper',
  OTHER: 'icon icon-plus',
  PAPERBACK: 'icon icon-book-open',
  PLAYAWAY_AUDIOBOOK: 'icon icon-headphones',
  PLAYAWAY_MUSIC: 'icon icon-music',
  VC: 'icon icon-videocam',
  VIDEO_GAME: 'icon icon-gamepad',
  VIDEO_ONLINE: 'icon icon-videocam',
  BR: 'icon icon-font',
  ATLAS: 'icon icon-book-open',
  PASS: 'icon icon-book-open',
  SPOKEN_CD: 'icon icon-headphones',
  VIDEO_DOWNLOAD: 'icon icon-videocam'
};

function getIconForFormat(format) {
  if (iconMap[format]) {
    return iconMap[format];
  }
  return 'icon icon-plus';
}

function getDigitalFormatTypeString(formatName) {
  switch (formatName) {
    case 'VIDEO':
    case 'STREAMING_VIDEO':
      return 'video';
    case 'MUSIC':
    case 'MUSIC_ONLINE':
      return 'music';
    case 'OVERDRIVE_MP3_AUDIOBOOK':
    case 'OVERDRIVE_WMA_AUDIOBOOK':
      return 'audiobook';
    case 'OVERDRIVE_MEDIA_DO':
      return 'media_do';
    default:
      return 'ebook';
  }
}

/* istanbul ignore next */
/* eslint-disable global-require */
function getDefaultImage(format) {
  // Dynamic requires are to be avoided in webpack because webpack will
  // include the whole directory recursively since it can't figure out what needs
  // to be included at compile time.
  //
  // The fix for this is to create a context for the require and pass the regex
  // for the files to require.

  // However require.context doesn't work on server side need to upgrade WebpackIsomorphicTools.
  // For now we will hardcode the URLs and created CORE-34581.
  // TODO: CORE-34581 - Upgrade WebpackIsomorphicTools so we don't have to hardcode image URLs

  switch (format) {
    case 'AB':
      return require('@bibliocommons/assets/images/default_covers/icon-audio.png');
    case 'BK':
    case 'BOARD_BK':
    case 'BOOK_CLUB_KIT':
    case 'BOOK_PCD':
    case 'GRAPHIC_NOVEL':
    case 'PAPERBACK':
      return require('@bibliocommons/assets/images/default_covers/icon-book.png');
    case 'RESTRICTED_BOOK_CD':
    case 'SPOKEN_CD':
    case 'TB':
    case 'DAISY':
      return require('@bibliocommons/assets/images/default_covers/icon-audio-cd.png');
    case 'RESTRICTED_BOOK_CS':
    case 'CS':
      return require('@bibliocommons/assets/images/default_covers/icon-audio-cassette.png');
    case 'EBOOK':
      return require('@bibliocommons/assets/images/default_covers/icon-book-eformat.png');
    case 'LPRINT':
      return require('@bibliocommons/assets/images/default_covers/icon-book-largeprint.png');
    case 'FILM':
    case 'NONSTANDARD_VIDEO':
      return require('@bibliocommons/assets/images/default_covers/icon-movie.png');
    case 'BLURAY':
    case 'DVD':
      return require('@bibliocommons/assets/images/default_covers/icon-movie-alldiscs.png');
    case 'VC':
      return require('@bibliocommons/assets/images/default_covers/icon-movie-cassette.png');
    case 'VIDEO_DOWNLOAD':
    case 'VIDEO_ONLINE':
      return require('@bibliocommons/assets/images/default_covers/icon-movie-eformat.png');
    case 'MP3_CD':
    case 'BOOK_CD':
      return require('@bibliocommons/assets/images/default_covers/icon-audio-cd.png');
    case 'CDROM':
    case 'VIDEO_GAME':
      return require('@bibliocommons/assets/images/default_covers/icon-games.png');
    case 'COMIC_BK':
    case 'MAG':
    case 'NEWSPAPER':
      return require('@bibliocommons/assets/images/default_covers/icon-journal.png');
    case 'EJ':
      return require('@bibliocommons/assets/images/default_covers/icon-journal-eformat.png');
    case 'WEBSITE':
      return require('@bibliocommons/assets/images/default_covers/icon-website.png');
    case 'LP':
      return require('@bibliocommons/assets/images/default_covers/icon-music.png');
    case 'MN':
    case 'MANUSCRIPT_MUSIC':
      return require('@bibliocommons/assets/images/default_covers/icon-music-sheet.png');
    case 'MUSIC_CD':
      return require('@bibliocommons/assets/images/default_covers/icon-music-cd.png');
    case 'MUSIC_ONLINE':
    case 'MUSIC_DOWNLOAD':
      return require('@bibliocommons/assets/images/default_covers/icon-music-eformat.png');
    case 'DEVICE':
    case 'PLAYAWAY_AUDIOBOOK':
    case 'PLAYAWAY_MUSIC':
    case 'PRELOADED_EBOOK':
    case 'PRELOADED_VIDEO_PLAYER':
      return require('@bibliocommons/assets/images/default_covers/icon-device-all.png');
    case 'ONLINE_IMAGE':
      return require('@bibliocommons/assets/images/default_covers/icon-webimage.png');
    default:
      return require('@bibliocommons/assets/images/default_covers/icon-other.png');
  }
}
/* eslint-enable global-require */

exports.default = {
  getIconForFormat: getIconForFormat,
  getDigitalFormatTypeString: getDigitalFormatTypeString,
  getDefaultImage: getDefaultImage
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-format/lib/index.js
// module id = 96
// module chunks = 1